export default __webpack_public_path__ + "static/char-03-4a1ae928679be2f9258ef2637f7e9fe7.webp";